<div style="display: flex; align-items: center; justify-content: center; flex-direction: column; width:100%; height: 100%;">
    <h1 style="margin-bottom: 2rem;">Vous n'êtes pas autorisé à accéder à l'application !</h1>
    <button nz-button nzType="primary" (click)="goBack()" nzShape="round" style="width: 200px;">Retour</button>
</div>

